// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".J8uwKNEAJxf02j_G5h16 {\n  max-width: 94px;\n  margin: 0 auto;\n  padding: 40px 15px;\n}", "",{"version":3,"sources":["webpack://./src/js/_components/_styles/Loading.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AACF","sourcesContent":[".wrap {\r\n  max-width: 94px;\r\n  margin: 0 auto;\r\n  padding: 40px 15px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": "J8uwKNEAJxf02j_G5h16"
};
export default ___CSS_LOADER_EXPORT___;
